import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { TFormRowAction } from '../columns/formColumns';
import type { ISampleForm } from '../sampleData';
import RowActionsMenu from './RowActionsMenu';

interface IProps {
  form: ISampleForm;
  onAction: (form: ISampleForm, action: TFormRowAction) => void;
}

function FormRowActions({ form, onAction }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <RowActionsMenu
      actions={[
        { action: 'edit', label: t('Edit') },
        { action: 'duplicate', label: t('Duplicate') },
        { action: 'rename', label: t('Rename') },
        {
          action: 'delete',
          isDestructive: true,
          label: t('Delete'),
          showDividerBefore: true,
        },
      ]}
      onAction={(action): void => onAction(form, action as TFormRowAction)}
    />
  );
}

export default FormRowActions;
